/**
 * Größenregal
 *
 * Jede Kachel bringt ihre Bestände je Größe als Daten mit. Beim Wechsel der
 * Größe wird nur umgeschaltet – kein Nachladen, keine Abfrage im Hintergrund.
 * Nicht lieferbare Teile bleiben stehen und werden ausgegraut, damit man sieht,
 * was es gäbe, wenn die Größe passt.
 *
 * Die Größe kommt aus der Adresse (?groesse=L), sonst aus der letzten Wahl im
 * Browser, sonst die erste Größe mit Bestand.
 */
(() => {
  const SPEICHER = 'ewear_groesse';

  document.querySelectorAll('[data-shelf]').forEach((wurzel) => {
    if (wurzel.dataset.bereit === '1') return;
    wurzel.dataset.bereit = '1';

    const texte = JSON.parse(
      document.querySelector('[data-shelf-strings]')?.textContent || '{}'
    );
    const groessen = (wurzel.dataset.sizes || '').split(',').map((g) => g.trim()).filter(Boolean);
    const karten = [...wurzel.querySelectorAll('[data-shelf-card]')];
    const knoepfe = [...wurzel.querySelectorAll('[data-shelf-size]')];
    const titelGroesse = wurzel.querySelector('[data-shelf-title-size]');
    const zusammenfassung = wurzel.querySelector('[data-shelf-summary]');

    const bestand = (karte) => {
      if (!karte._bestand) {
        try {
          karte._bestand = JSON.parse(karte.dataset.stock);
        } catch (_) {
          karte._bestand = {};
        }
      }
      return karte._bestand;
    };

    /** Größe mit dem meisten Bestand – als Startwert, wenn nichts gewählt ist. */
    const beste = () => {
      let treffer = groessen[0];
      let hoechste = -1;
      groessen.forEach((g) => {
        const summe = karten.reduce((a, k) => {
          const e = bestand(k)[g];
          return a + (e && e.frei ? Math.max(e.menge, 1) : 0);
        }, 0);
        if (summe > hoechste) {
          hoechste = summe;
          treffer = g;
        }
      });
      return treffer;
    };

    const anwenden = (groesse) => {
      let verfuegbar = 0;

      karten.forEach((karte) => {
        const eintrag = bestand(karte)[groesse] || null;
        const frei = Boolean(eintrag && eintrag.frei);
        const menge = eintrag ? eintrag.menge : 0;

        karte.classList.toggle('is-weg', !frei);
        const zustand = karte.querySelector('[data-shelf-state]');
        const meta = karte.querySelector('[data-shelf-meta]');
        const link = karte.querySelector('[data-shelf-link]');

        if (frei) {
          verfuegbar += 1;
          const knapp = menge > 0 && menge <= 3;
          zustand.textContent = '';
          zustand.hidden = true;
          meta.textContent = menge > 0
            ? (knapp ? texte.lastOnes : texte.available).replace('__n__', menge)
            : '';
          meta.classList.toggle('is-knapp', knapp);
          if (eintrag.id) {
            const basis = link.getAttribute('href').split('?')[0];
            link.setAttribute('href', basis + '?variant=' + eintrag.id);
          }
          link.removeAttribute('aria-disabled');
        } else {
          zustand.hidden = false;
          zustand.textContent = texte.soldOut;
          meta.textContent = '';
          meta.classList.remove('is-knapp');
          link.setAttribute('aria-disabled', 'true');
        }
      });

      knoepfe.forEach((k) => {
        k.setAttribute('aria-pressed', String(k.dataset.shelfSize === groesse));
      });

      if (titelGroesse) titelGroesse.textContent = (texte.inSize || '').replace('__s__', groesse);
      if (zusammenfassung) {
        zusammenfassung.textContent = verfuegbar
          ? (texte.summary || '').replace('__n__', verfuegbar).replace('__s__', groesse)
          : (texte.summaryNone || '').replace('__s__', groesse);
      }

      try {
        window.localStorage.setItem(SPEICHER, groesse);
      } catch (_) {}

      const adresse = new URL(window.location.href);
      adresse.searchParams.set('groesse', groesse);
      window.history.replaceState({}, '', adresse);
    };

    knoepfe.forEach((knopf) => {
      knopf.addEventListener('click', () => anwenden(knopf.dataset.shelfSize));
    });

    const ausAdresse = new URLSearchParams(window.location.search).get('groesse');
    let gemerkt = null;
    try {
      gemerkt = window.localStorage.getItem(SPEICHER);
    } catch (_) {}

    const start = [ausAdresse, gemerkt].find((g) => g && groessen.includes(g)) || beste();
    anwenden(start);
  });
})();
